module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_0.32421854.png";